import styled from "styled-components";
import { Modal } from "@/components/renderbus-modal";
import { Form, Input } from "@renderbus/ui";
import { FormProps, Space } from "antd";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import { ValidatorRule } from "rc-field-form/lib/interface";
import { RenderbusModalProps } from "@renderbus/ui/components/modal";

export function ChangeNameModal({
  modalProps,
  formProps,
}: {
  modalProps?: RenderbusModalProps;
  formProps?: FormProps;
}) {
  const { userInfo } = useGlobalStore();
  const { t } = useTranslation("profile");
  const validateName: ValidatorRule["validator"] = (_, v) => {
    const value = v || "";
    if (!value) {
      return Promise.reject(t("account_login_modify_tip_null"));
    }
    if (value === userInfo?.userName) {
      return Promise.reject(t("user_modify_error_tip_same"));
    }
    if (!/^(?![0-9]+$)(?![_]+$)[0-9A-Za-z_]{6,20}$/.test(value)) {
      return Promise.reject(t("user_modify_error_tip"));
    }
    return Promise.resolve();
  };
  return (
    <Modal {...modalProps}>
      <FormWrapper>
        <Space size={12} style={{ marginBottom: "30px" }}>
          <FormLabel>{t("account_login_current")}</FormLabel>
          <FormValue>{userInfo?.userName}</FormValue>
        </Space>
        <Form
          {...formProps}
          initialValues={{
            afterUserName: userInfo?.userName,
          }}
        >
          <Form.Item
            name="afterUserName"
            label={t("account_login_new")}
            style={{ color: "#D4D4D4" }}
            required
            rules={[{ validator: validateName }]}
          >
            <Input
              type="text"
              style={{
                width: "460px",
              }}
              placeholder={t("account_login_modify_tip_null")}
            />
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
}

const FormLabel = styled.div`
  color: #d4d4d4;
  font-size: 14px;
`;
const FormValue = styled.div`
  color: #d9dfe0;
  font-size: 14px;
  font-weight: 600;
`;
const FormWrapper = styled.div`
  padding: 30px 0 0 70px;
  .renderbus-ui--form .ant-form-item-label {
    height: 34px;
    label {
      color: #d4d4d4;
    }
  }
  input {
    background: #2c2c31 !important;
  }
`;
